import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom'
import ScrollToTop from './ScrollToTop';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './AuthConfig';
import AzureAppWraper from './componets/Azure/AzureAppWraper';
import { AuthProvider, useAuth } from "./AuthProvider";
import LogoutDialog from "./componets/LogoutDialog";
const Root = () => {
    const { showLogoutDialog, confirmLogout } = useAuth();

    return (
        <>
            <LogoutDialog visible={showLogoutDialog} onHide={confirmLogout} />
            <App />
        </>
    );
};

ReactDOM.render(
    <HashRouter>
        <ScrollToTop>
            <AzureAppWraper msalConfig={msalConfig}>
                <AuthProvider>
                    <Root />
                </AuthProvider>
            </AzureAppWraper>
        </ScrollToTop>
    </HashRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();